"use client";

import { createContext, use } from "react";

import type { AccessTokenPayload } from "../../core";

export type AuthenticationContextValue = { accessTokenPayload?: AccessTokenPayload; authenticated?: boolean };

export const AuthenticationContext = createContext<AuthenticationContextValue>({
  authenticated: undefined,
  accessTokenPayload: undefined,
});

export const useAuthenticationContext = () => use(AuthenticationContext);
